module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "loginType clearfix"
  }, [_c('div', {
    staticClass: "loginTypeItem",
    class: {
      active: !_vm.isMsg
    },
    staticStyle: {
      "color": "#3068ff"
    },
    on: {
      "click": function($event) {
        return _vm.changeLoginType(false)
      }
    }
  }, [_vm._v("账号登录")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "inputItem clearfix"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    ref: "fInp",
    attrs: {
      "type": "tel",
      "placeholder": "请输入手机号",
      "id": "testInp",
      "autocomplete": "off",
      "onfocus": "this.type='phone'"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.isGetCode && _vm.isMsg) ? _c('span', {
    staticClass: "sendCode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.isGetCode && _vm.isMsg) ? _c('span', {
    staticClass: "sendCode"
  }, [_vm._v(_vm._s(_vm.time + ' s'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "inputItem"
  }, [(_vm.isMsg) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请输入短信验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), (!_vm.isMsg) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "autocomplete": "off",
      "onfocus": "this.type='password'"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "forgetPW",
    staticStyle: {
      "padding-top": "9%",
      "margin-bottom": "0",
      "font-size": "20px"
    }
  }, [_vm._v("\n                酒吧/KTV/茶楼等后台登录？"), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeUrl.apply(null, arguments)
      }
    }
  }, [_vm._v("点击切换至旗舰版")])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup clearfix"
  }, [_c('button', {
    staticClass: "loginBtn right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('button', {
    staticClass: "regisBtn left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/register'
        });
      }
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "forgetPW"
  }, [_vm._v("\n                忘记密码？"), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/register/reset'
        });
      }
    }
  }, [_vm._v("重置密码 / 修改密码")]), _vm._v(" "), _c('a', {
    staticClass: "dw",
    attrs: {
      "href": "/static/火星捕手点单系统安装包_V1.1.3.exe.zip",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("下载收银端")])])])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/login/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("基于云计算SaaS模式")]), _vm._v(" "), _c('p', [_vm._v("收银、营销一体化服务平台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "left iconSpan"
  }, [_c('i', {
    staticClass: "iconfont icon-mobile"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "left iconSpan"
  }, [_c('i', {
    staticClass: "iconfont icon-mima"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-info"
  }, [_c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v("蜀ICP备17028712号-1")]), _vm._v(" 火星云网络科技有限公司 huoxingy.co"), _c('a', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "target": "_blank",
      "href": "/static/bq.zip"
    }
  }, [_vm._v("m")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4aa079b9","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/login.vue
// module id = 945
// module chunks = 1